export default __webpack_public_path__ + "static/media/logoAudiaciaLight.b6441c28.png";